import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";
import RouterConstants from "../../constants/RouterConstants";
import TabsLayout, { ITabLayout } from "../../layout/TabsLayout/TabsLayout";
import styles from "./Models.module.scss";

const Models = () => {
	const { t } = useTranslation("translation", { keyPrefix: "models" });
	const subTabs: ITabLayout[] = [
		{ name: t("overview.tab"), link: RouterConstants.MODELS.OVERVIEW.path },
		{ name: t("attributionService.tab"), link: RouterConstants.MODELS.ATTRIBUTION_SERVICE.path },
	];

	return (
		<TabsLayout contentClassName={styles.content} title={t("header")} subTabs={subTabs}>
			<Outlet />
		</TabsLayout>
	);
};

export default observer(Models);
